import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* ランキングへの目立つリンク */}
        <div className="mb-12 text-center">
          <Link
            to="/ranking"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold px-8 py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer"
          >
            <i className="ri-trophy-line text-2xl"></i>
            <span className="text-lg">人気クレジットカード比較ランキングはこちら</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center">
                <i className="ri-bank-card-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold">クレカ比較ナビ</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              あなたにぴったりのクレジットカードが見つかる比較サイト。年会費、ポイント還元率、特典などを徹底比較して、最適な1枚を見つけましょう。
            </p>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-white">人気カード</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/mitsui" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  三井住友カード（NL）
                </Link>
              </li>
              <li>
                <Link to="/rakuten" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  大手ECモール系カード
                </Link>
              </li>
              <li>
                <Link to="/dcard" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  dカード GOLD U
                </Link>
              </li>
              <li>
                <Link to="/recruit" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  リクルートカード
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-white">お役立ち記事</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/articles/instant-issue" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  即日発行カード
                </Link>
              </li>
              <li>
                <Link to="/articles/free-annual-fee" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  年会費無料カード
                </Link>
              </li>
              <li>
                <Link to="/articles/high-return-rate" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  高還元率カード
                </Link>
              </li>
              <li>
                <Link to="/articles/rakuten-vs-mitsui" className="text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap">
                  大手ECモール系vs三井住友比較
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2026 クレカ比較ナビ. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-teal-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
